import { Button, Grid, Card,  CircularProgress, makeStyles, Typography } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getEstadisticasUsuarios, DescargarExcelUsuarios } from '../../actions/miOspedyc/estadisticasMiOspedyc';
import TableGeneric from '../compartidos/abms/TableGeneric';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";


const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    rootDatos: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        padding: 10,
        marginTop: 20
    },
    button: {
        marginTop: theme.spacing(2),
        float: "right"
    },
    input: {
        display: 'none',
    },
}));

const UsuariosScreen = () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const { usuarios, loading } = useSelector(state => state.estadisticasMiOspedyc)

    useEffect(() => {
        dispatch(getEstadisticasUsuarios())
        // eslint-disable-next-line
    }, []);
const downloadExcel = () => {
dispatch(DescargarExcelUsuarios());
}
    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} md={10}>
                    <Card>
                        <Typography variant="subtitle1" style={{ padding: 16 }}>
                            Listado de Usuarios
                            {
                                loading &&
                                <CircularProgress size={24} style={{ marginLeft: 15 }} />
                            }
                             <Button
                            component="span"
                            variant="contained"
                            color="primary"
                            style={{ borderRadius: "3px 0px 0px 3px", float:"right"}}
                            startIcon={<CloudDownloadIcon />}
                            onClick={downloadExcel}
                        >
                            Descargar
                        </Button>
                        </Typography>
                        <TableGeneric
                            data={usuarios}
                            columns={[
                                {
                                    label: "Nombre y Apellido",
                                    id: "nombreApellido",
                                    sort: true
                                },
                                {
                                    label: "DNI",
                                    id: "dni",
                                    sort: true,
                                },
                                {
                                    label: "Password",
                                    id: "password",
                                },
                                {
                                    label: "Edad",
                                    id: "edad",
                                    sort: true,
                                },
                                {
                                    label: "Correo electrónico",
                                    id: "email",
                                },
                                {
                                    label: "Tiempo de uso de la App (min)",
                                    id: "tiempoDeUsoApp",
                                    sort: true,
                                }
                            ]}
                        />
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default UsuariosScreen
